import { GetAdminPermissionsForUserResponse } from '@cbinsights/adminpermissionservice/adminpermissionservice';
import { request } from 'client/modules/common/utils/request';

export const getAdminPermissionsForUser =
  (): Promise<GetAdminPermissionsForUserResponse> =>
    request({
      url: '/service/adminpermissionservice/GetAdminPermissionsForUser',
    }).then((r) => {
      return r.body as GetAdminPermissionsForUserResponse;
    });
